import $ from '../core/Dom';
import EcoMode from '../lib/EcoMode';
import { loadGsap } from '../lib/async-bundles';

export default (el, props) => {
    const $el = $(el);

    let $current = null;
    let gsap = null;
    
    const init = () => {
        if (EcoMode.shouldAnimate()) {
            loadGsap(({ default: loadedData }) => {
                gsap = loadedData;
                // gsap.defaults({ overwrite: 'auto' });
            });
        }
        
        $el.on('click', 'button', e => {
            const $button = $(e.triggerTarget);
            toggle($button);
        });
    };

    const destroy = () => {
        $el.off('click');
    };

    const toggle = $button => {
        const $content = $button.parent().next();
        const expanded = $button.attr('aria-expanded') === 'true' || false;

        $button.attr('aria-expanded', !expanded);

        if (expanded) {
            collapse($content);
            $current = null;
        } else {
            expand($content);
            $current = $button;
        }
    };

    const collapse = $content => {
        if (gsap) {
            gsap.to($content.get(0), {
                duration: 0.3, height: 0, ease: 'quint.inOut', onComplete: () => {
                    $content.attr('hidden', '');
                }
            });
        } else {
            $content.css({ height: 0 }).attr('hidden', '');
        }
        $content.parent().removeClass('selected');
    };

    const expand = $content => {
        if ($current !== null) {
            //toggle($current)
        }

        $content.attr('hidden', null);
        
        if (gsap) {
            gsap.set($content.get(0), {
                height: 0,
                overflow: 'hidden'
            });
            gsap.to($content.get(0), {
                duration: 0.5,
                height: 'auto',
                ease: 'quint.inOut'
            });
        } else {
            $content.css({ height: 'auto' });
        }
        
        $content.parent().addClass('selected');
    };

    return {
        init,
        destroy
    };
};
